import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import {
    UserStatusWithdrawalLimitsProgressCardLineStyled,
    UserStatusWithdrawalLimitsProgressCardStyled,
} from './styled/UserStatusWithdrawalLimitsProgressCardStyled';
import amountFormat from '../../../../utils/amountFormat';
import React, { useMemo } from 'react';
import _ from 'lodash';

interface IUserStatusWithdrawalLimitsPeriodProgressCardProps {
    limit?: number,
    limitUpdateDate: string,
    periodCurrentAmount: number,
    title: string,
}

function UserStatusWithdrawalLimitsProgressCard(props: IUserStatusWithdrawalLimitsPeriodProgressCardProps) {
    const { limit, limitUpdateDate, periodCurrentAmount, title } = props;
    const { getLangPath } = useLangContext();

    const amountLeft = useMemo(() => limit
            ? _.max([
                _.round(limit - periodCurrentAmount, 2),
                0,
            ])
            : 0,
        [limit, periodCurrentAmount]);

    const percent = useMemo(() => amountLeft / limit * 100, [amountLeft, limit]);

    return <UserStatusWithdrawalLimitsProgressCardStyled>
        <span className={'text-secondary'}>{title}</span>
        {
            !limit
                ? <span>{getLangPath('user_statuses.withdrawal_limits.unlimited')}</span>
                : <>
                    <div className={'d-flex justify-content-between'}>
                        <span>
                            {getLangPath('user_statuses.withdrawal_limits.limit_left', {
                                amount: `${amountFormat(amountLeft, 2, '$')}`,
                            })}
                        </span>
                        <span className={'text-secondary'}>
                            {getLangPath('user_statuses.withdrawal_limits.of_limit', {
                                amount: `${amountFormat(limit, 2, '$')}`,
                            })}
                        </span>
                    </div>

                    <UserStatusWithdrawalLimitsProgressCardLineStyled percent={percent}/>

                    <span className={'f14 text-secondary'}>
                        {getLangPath('user_statuses.withdrawal_limits.limit_update')}: {limitUpdateDate}
                    </span>
                </>
        }
    </UserStatusWithdrawalLimitsProgressCardStyled>;
}

export default UserStatusWithdrawalLimitsProgressCard;
